import React from 'react'
import { Control, Controller, ControllerRenderProps } from 'react-hook-form'

import s from './styles.module.scss'

import { IconSvg } from '../../icons'

interface IQuotationField {
  url?: string | undefined
  setUrl?: React.Dispatch<React.SetStateAction<string | undefined>>
  label: string
  onClear: (field: ControllerRenderProps<any, any>) => void
  fileName?: string
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  name: string
  control: Control<any, any>
  required?: boolean
}

const UploadField = ({
  onFileChange,
  url,
  onClear,
  label,
  fileName,
  name,
  control,
  required,
}: IQuotationField & { control: any }) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null)

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={url}
      rules={{ required: required ? 'Ce champ est requis' : false }}
      render={({ field }) => {
        return (
          <div className={s.inputWrapper}>
            {!url ? (
              <>
                <input
                  {...field}
                  type='file'
                  className={s.input}
                  accept='.pdf'
                  name={name}
                  onChange={(e) => {
                    onFileChange(e)
                    field.onChange(e)
                  }}
                  ref={fileInputRef}
                />

                <button className={s.button}>
                  <IconSvg.AttachFile color='black' height={13} width={13} />
                  {label}
                </button>
              </>
            ) : (
              <>
                <IconSvg.Close
                  color='black'
                  height={13}
                  width={13}
                  onClick={() => onClear(field)}
                  className={s.crossIcon}
                />
                <a href={url} download className={s.downloadLink}>
                  {fileName}
                </a>
              </>
            )}
          </div>
        )
      }}
    />
  )
}

export default UploadField
